export default __webpack_public_path__ + "media/vendor/paper-dashboard-2-pro-html-v2.0.1/assets/img/flags/LU-faf08d6bae6516a046ee249a91876cd7.png";